export default __webpack_public_path__ + "static/media/bean-2.dffb246a.png";